import React from 'react';
import { FcViewDetails } from 'react-icons/fc';
import { OrderModel } from '@app/interfaces/order';
import { Tabs } from 'antd';
import { HistoryOutlined } from '@ant-design/icons';
import { MdOutlinePayments } from "react-icons/md";
import Overview from '../detail/Overview';
import PaymentTransaction from '../detail/PaymentTransaction';
import Activities from '../detail/Activities';
import { usePermissions } from '@app/hooks/usePermissions';

interface OrderDetailProps {
  record: OrderModel;
  activitiesRefreshToken?: number;
}

const OrderDetailTabs: React.FC<OrderDetailProps> = ({ record, activitiesRefreshToken }) => {
  // Tab Activities gọi /api/orders/:id/activities (cần orders:activities); không có quyền
  // mà vẫn hiện thì bấm vào sẽ 403 và bị đẩy sang /403.
  const { can } = usePermissions();

  return (
    <Tabs defaultActiveKey="1" size="middle">
      <Tabs.TabPane
        tab={
          <span>
            <FcViewDetails /> Thông tin đơn hàng
          </span>
        }
        key="orderTabOverivew"
      >
        <Overview record={record} />
      </Tabs.TabPane>
      <Tabs.TabPane
        tab={
          <span>
            <MdOutlinePayments /> Lịch sử thanh toán
          </span>
        }
        key="orderPaymentTab"
      >
        <PaymentTransaction record={record} />
      </Tabs.TabPane>
      {can('orders', 'activities') && (
        <Tabs.TabPane
          tab={
            <span>
              <HistoryOutlined /> Activities
            </span>
          }
          key="orderTabActivities"
        >
          <Activities orderId={Number(record.id)} refreshToken={activitiesRefreshToken} />
        </Tabs.TabPane>
      )}
    </Tabs>
  );
};

export default OrderDetailTabs;
